module.exports = __webpack_public_path__ + "static/media/HF-logo.9d395144.png";